export type Publication = 'blog' | 'newsroom'

export const PUBLICATION_LABELS = { blog: 'Blog', newsroom: 'Newsroom' } as const
export const NEWSROOM_CATEGORIES = ['お知らせ', 'サービス', 'ニュースレター', 'イベント'] as const
export const DEFAULT_THUMBNAIL = '/placeholderThumbnail.png'

export type BlogPostStatus = 'draft' | 'published'

export interface CoverImageCredit {
  author: string
  authorUrl: string
  sourceUrl: string
}

export interface BlogPost {
  publication: Publication
  slug: string
  title: string
  category: string
  excerpt: string
  content: string
  coverImage: string
  coverImageCredit: CoverImageCredit | null
  author: string
  status: BlogPostStatus
  publishedAt: string | null
  createdAt: string | null
  updatedAt: string | null
}

export interface BlogPostInput {
  publication: Publication
  slug: string
  title: string
  category: string
  excerpt: string
  content: string
  coverImage: string
  coverImageCredit: CoverImageCredit | null
  author: string
  status: BlogPostStatus
}

export const BLOG_CATEGORIES = [
  'Insights',
  'Guides',
  'Field Notes',
  'Perspectives',
] as const

export const BLOG_AUTHORS = [
  'Bybeit Team',
  'Hinata Yamasaki, CEO',
  'Haruhiro Matsumoto, CTO and CPO',
] as const
